/*
 *******************************************************************************
 *
 *  Filename:   ./agents/agentBrokers.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Brokers API endpoints.
 *
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *
 *
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests'

export const Brokers = {
  all: () =>
    requests.postLambda('/miiBrokers', {
      action: 'getBrokers',
      paramters: {},
    }),
  get: (brokerid) =>
    requests.postLambda(`/miiBrokers`, {
      action: 'getBroker',
      paramters: {
        brokerid: brokerid,
      },
    }),
  create: (broker) =>
    requests.postLambda(`/miiBrokers`, {
      action: 'createBroker',
      parameters: {
        fullname: broker.fullname,
        email: broker.email,
        practicename: broker.practicename,
        website: broker.website,
        goals: broker.goals,
        interests: broker.interests,
      },
    }),
  update: (brokerid, broker) =>
    requests.postLambda(`/miiBrokers`, {
      action: 'editBroker',
      parameters: {
        brokerid: brokerid,
        fullname: broker.fullname,
        email: broker.email,
        practicename: broker.practicename,
        website: broker.website,
        goals: broker.goals,
        interests: broker.interests,
      },
    }),
  delete: (brokerid) =>
    requests.postLambda(`/miiBrokers`, {
      action: 'deleteBroker',
      parameters: {
        brokerid: brokerid,
      },
    }),
}
